import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-40px" });
  const active = inView ? seen : true;
  return (
    <span ref={ref} className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={active ? { y: "0%" } : { y: "115%" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const Segments = ({ segments, accentClass = "text-noom-lilacHover" }) =>
  segments.map((s, i) =>
    s.a ? (
      <span key={i} className={accentClass}>
        {s.t}
      </span>
    ) : (
      <span key={i}>{s.t}</span>
    )
  );

export const ChapterLabel = ({ children, dark = false, testId }) => (
  <Reveal y={14}>
    <p
      data-testid={testId}
      className={`font-mono text-[11px] uppercase tracking-[0.28em] ${
        dark ? "text-noom-lilac" : "text-noom-lilacDeep"
      }`}
    >
      {children}
    </p>
  </Reveal>
);

export const Asterisk = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
  </svg>
);
